// extracted by mini-css-extract-plugin
export default {"container":"SidebarHeader_container__43oaJ","filterIcon":"SidebarHeader_filterIcon__pDDBd","closeIcon":"SidebarHeader_closeIcon__2+djA"};